import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #e8e3f5;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 12px;
  width: 95%;

  @media (max-width: 770px) {
    width: 100%;
    padding: 12px;
    margin-bottom: 16px;
  }
`;

export const Icon = styled.div`
  width: 24px;
  height: 24px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 24px;
    height: 24px;
  }
`;

export const Text = styled.p`
  font-size: 12px;
  color: #333333;
  margin: 0;
  line-height: 1.4;

  @media (max-width: 770px) {
    font-size: 11px;
  }
`;

export const Link = styled.a`
  color: #000fff;
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;
